import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';

const BIIndex = lazy(() => import('./Index'));
const BIAdmin = lazy(() => import('./Admin'));
const BIFinanceiroRegras = lazy(() => import('./adminFinanceiroRegras'));
const BIDashboard = lazy(() => import('./Dashboard'));
const BIMetabaseAdmin = lazy(() => import('./metabase/Admin'));
const HierarquiaIndex = lazy(() => import('./hierarquia/Index'));
const HierarquiaPendencias = lazy(() => import('./hierarquia/PendenciasVinculo'));
const HierarquiaImportar = lazy(() => import('./hierarquia/Importar'));
const HierarquiaDuplicados = lazy(() => import('./hierarquia/Duplicados'));
const HierarquiaInatividade = lazy(() => import('./hierarquia/Inatividade'));
const HierarquiaAlteracoes = lazy(() => import('./hierarquia/Alteracoes'));

export const biRoutes: RouteObject[] = [
    {
        path: '/bi',
        element: (
            <ProtectedRoute permission="bi.view">
                <BIIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: '/bi/admin',
        element: (
            <ProtectedRoute permission="bi.admin">
                <BIAdmin />
            </ProtectedRoute>
        ),
    },
    {
        // Regras Sim/Não da carteira do Financeiro. Antes do wildcard /bi/*.
        path: '/bi/admin/financeiro/recebiveis',
        element: (
            <ProtectedRoute anyOf={['bi.financeiro-recebiveis.manage', 'bi.admin']}>
                <BIFinanceiroRegras />
            </ProtectedRoute>
        ),
    },
    {
        // Antes do wildcard /bi/* — cadastro dos embeds do Metabase.
        path: '/bi/metabase',
        element: (
            <ProtectedRoute permission="bi.metabase.manage">
                <BIMetabaseAdmin />
            </ProtectedRoute>
        ),
    },
    {
        // Hierarquia comercial — painel de cadastro, ainda isolado (não alimenta
        // nenhuma análise). Antes do wildcard /bi/*.
        path: '/bi/hierarquia',
        element: (
            <ProtectedRoute permission="bi.hierarquia.view">
                <HierarquiaIndex />
            </ProtectedRoute>
        ),
    },
    {
        path: '/bi/hierarquia/pendencias',
        element: (
            <ProtectedRoute permission="bi.hierarquia.view">
                <HierarquiaPendencias />
            </ProtectedRoute>
        ),
    },
    { path: '/bi/hierarquia/conciliacao', element: <Navigate to="/bi/hierarquia/pendencias" replace /> },
    {
        path: '/bi/hierarquia/duplicados',
        element: (
            <ProtectedRoute permission="bi.hierarquia.view">
                <HierarquiaDuplicados />
            </ProtectedRoute>
        ),
    },
    {
        path: '/bi/hierarquia/importar',
        element: (
            <ProtectedRoute permission="bi.hierarquia.manage">
                <HierarquiaImportar />
            </ProtectedRoute>
        ),
    },
    {
        path: '/bi/hierarquia/inatividade',
        element: (
            <ProtectedRoute permission="bi.hierarquia.manage">
                <HierarquiaInatividade />
            </ProtectedRoute>
        ),
    },
    {
        path: '/bi/hierarquia/alteracoes',
        element: (
            <ProtectedRoute permission="bi.hierarquia.view">
                <HierarquiaAlteracoes />
            </ProtectedRoute>
        ),
    },
    {
        path: '/bi/*',
        element: (
            <ProtectedRoute permission="bi.view">
                <BIDashboard />
            </ProtectedRoute>
        ),
    },
];
